import React from "react";
import {
  Box,
  FormControlLabel,
  MenuItem,
  Paper,
  Stack,
  Switch,
  TextField,
  Typography,
} from "@mui/material";

export default function ProductDetailsForm({
  form,
  onChange,
  loading,
  finalPrice,
  offerFinalPrice,
}) {
  return (
    <Paper
      sx={{
        width: "100%",
        borderRadius: "18px",
        border: "1px solid rgba(148,163,184,0.2)",
        boxShadow: "0 16px 36px rgba(15,23,42,0.05)",
        p: { xs: 2, md: 2.4 },
        bgcolor: "#ffffff",
      }}
    >
      <Stack spacing={2}>
        <Box>
          <Typography
            sx={{
              color: "#0f172a",
              fontSize: { xs: 16, md: 17.5 },
              fontWeight: 800,
            }}
          >
            Datos del producto
          </Typography>

          <Typography
            sx={{
              color: "#64748b",
              fontSize: 13,
              mt: 0.4,
            }}
          >
            Completa la información comercial y operativa.
          </Typography>
        </Box>

        <Box
          sx={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1.5fr 1fr" },
            gap: 2,
          }}
        >
          <TextField
            label="Nombre"
            value={form.name}
            onChange={(event) => onChange("name", event.target.value)}
            fullWidth
            disabled={loading}
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                height: 40,
                borderRadius: "10px",
                bgcolor: "#f8fafc",
              },
              "& .MuiInputLabel-root": {
                fontWeight: 500,
                color: "#64748b",
              },
            }}
          />

          <TextField
            select
            label="IVA"
            value={form.iva_percentage}
            onChange={(event) => onChange("iva_percentage", event.target.value)}
            fullWidth
            disabled={loading}
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                height: 40,
                borderRadius: "10px",
                bgcolor: "#f8fafc",
              },
              "& .MuiInputLabel-root": {
                fontWeight: 500,
                color: "#64748b",
              },
            }}
          >
            <MenuItem value={0}>0%</MenuItem>
            <MenuItem value={5}>5%</MenuItem>
            <MenuItem value={15}>15%</MenuItem>
            <MenuItem value={999}>No objeto de IVA</MenuItem>
          </TextField>
        </Box>

        <TextField
          label="Descripción"
          value={form.description}
          onChange={(event) => onChange("description", event.target.value)}
          fullWidth
          disabled={loading}
          multiline
          minRows={4}
          sx={{
            "& .MuiOutlinedInput-root": {
              borderRadius: "10px",
              bgcolor: "#f8fafc",
            },
            "& .MuiInputLabel-root": {
              fontWeight: 500,
              color: "#64748b",
            },
          }}
        />

        <Box
          sx={{
            width: "100%",
            display: "grid",
            gridTemplateColumns: { xs: "1fr", md: "1fr 1fr 1fr 1fr" },
            gap: 2,
          }}
        >
          <TextField
            label="Precio base"
            value={form.base_price}
            onChange={(event) => onChange("base_price", event.target.value)}
            fullWidth
            disabled={loading}
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                height: 40,
                borderRadius: "10px",
                bgcolor: "#f8fafc",
              },
              "& .MuiInputLabel-root": {
                fontWeight: 500,
                color: "#64748b",
              },
            }}
          />

          <TextField
            label="Precio final"
            value={finalPrice}
            fullWidth
            disabled
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                height: 40,
                borderRadius: "10px",
                bgcolor: "#eef2ff",
              },
              "& .MuiInputLabel-root": {
                fontWeight: 500,
                color: "#64748b",
              },
            }}
          />

          <TextField
            label="Stock"
            value={form.stock}
            onChange={(event) => onChange("stock", event.target.value)}
            fullWidth
            disabled={loading}
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                height: 40,
                borderRadius: "10px",
                bgcolor: "#f8fafc",
              },
              "& .MuiInputLabel-root": {
                fontWeight: 500,
                color: "#64748b",
              },
            }}
          />

          <TextField
            label="Stock mínimo"
            value={form.stock_minimum}
            onChange={(event) => onChange("stock_minimum", event.target.value)}
            fullWidth
            disabled={loading}
            size="small"
            sx={{
              "& .MuiOutlinedInput-root": {
                height: 40,
                borderRadius: "10px",
                bgcolor: "#f8fafc",
              },
              "& .MuiInputLabel-root": {
                fontWeight: 500,
                color: "#64748b",
              },
            }}
          />
        </Box>

        <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
          <FormControlLabel
            control={
              <Switch
                checked={Boolean(form.has_offer)}
                onChange={(event) => onChange("has_offer", event.target.checked)}
              />
            }
            label="Producto en oferta"
          />
        </Stack>

        {form.has_offer && (
          <Box
            sx={{
              width: "100%",
              display: "grid",
              gridTemplateColumns: { xs: "1fr", md: "1fr 1fr" },
              gap: 2,
            }}
          >
            <TextField
              label="Precio oferta"
              value={form.offer_price}
              onChange={(event) => onChange("offer_price", event.target.value)}
              fullWidth
              disabled={loading}
              size="small"
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: 40,
                  borderRadius: "10px",
                  bgcolor: "#f8fafc",
                },
                "& .MuiInputLabel-root": {
                  fontWeight: 500,
                  color: "#64748b",
                },
              }}
            />

            <TextField
              label="Oferta final"
              value={offerFinalPrice}
              fullWidth
              disabled
              size="small"
              sx={{
                "& .MuiOutlinedInput-root": {
                  height: 40,
                  borderRadius: "10px",
                  bgcolor: "#eef2ff",
                },
                "& .MuiInputLabel-root": {
                  fontWeight: 500,
                  color: "#64748b",
                },
              }}
            />
          </Box>
        )}

        <Stack direction={{ xs: "column", md: "row" }} spacing={2}>
          <FormControlLabel
            control={
              <Switch
                checked={Boolean(form.ecommerce)}
                onChange={(event) => onChange("ecommerce", event.target.checked)}
              />
            }
            label="Disponible en ecommerce"
          />

          <FormControlLabel
            control={
              <Switch
                checked={Boolean(form.is_active)}
                onChange={(event) => onChange("is_active", event.target.checked)}
              />
            }
            label="Producto activo"
          />
        </Stack>
      </Stack>
    </Paper>
  );
}